window.jpcCalc = function() {
  var g = function(id){ return document.getElementById(id); };
  var colab = parseInt((g('jpc-colab')||{}).value) || 0;
  var mulh  = parseInt((g('jpc-mulh')||{}).value)  || 0;
  var banh  = parseInt((g('jpc-banh')||{}).value)  || 1;
  var vis   = parseInt((g('jpc-vis')||{}).value)   || 0;
  var horas = parseInt((g('jpc-h')||{}).value)     || 12;
  var tipo  = (g('jpc-tipo')||{}).value            || 'escritorio';
  var fat = {
    escritorio:{phi:4.0,toa:2.5,sab:3.5},
    clinica:   {phi:5.0,toa:5.0,sab:6.0},
    hotel:     {phi:5.0,toa:4.0,sab:5.0},
    restaurante:{phi:3.5,toa:4.5,sab:4.0},
    condominio:{phi:4.0,toa:3.0,sab:3.5},
    colegio:   {phi:5.0,toa:4.0,sab:4.5}
  }[tipo] || {phi:4.0,toa:2.5,sab:3.5};
  var fh = Math.max(0.7, Math.min(horas/8, 2.5));
  var fm = mulh/100;
  var pessoas = colab + vis;
  var diasMes = 26;
  var phi_dia = (colab*(fm*fat.phi*1.6 + (1-fm)*fat.phi) + vis*fat.phi*0.5) * fh;
  var toa_dia = pessoas * fat.toa * fh;
  var sab_dia = pessoas * fat.sab * fh;
  var phi_pcts = Math.ceil(phi_dia * diasMes / 350);
  var toa_pcts = Math.ceil(toa_dia * diasMes / 240);
  var sab_refs = Math.ceil(sab_dia * diasMes / 2000);
  var d_phi = banh;
  var d_toa = banh;
  var d_sab = banh + Math.ceil(vis / 20);
  var s = function(id, v){ var el = g(id); if(el) el.textContent = v; };
  s('jpc-phi', phi_pcts);
  s('jpc-toa', toa_pcts);
  s('jpc-sab', sab_refs);
  s('jpc-d-phi', d_phi);
  s('jpc-d-toa', d_toa);
  s('jpc-d-sab', d_sab);
  var tipoL = {escritorio:'Escritório',clinica:'Clínica',hotel:'Hotel',restaurante:'Restaurante',condominio:'Condomínio',colegio:'Colégio'}[tipo]||tipo;
  
  // Product recommendations
  var recoDiv = g('jpc-reco');
  var recoCards = g('jpc-reco-cards');
  if(recoDiv && recoCards) {
    recoDiv.style.display = 'block';
    var products = {
      escritorio: [
        {name:'Rolão 500m EHR50',desc:'Mais vendido para empresas. 8x500m.',url:'/products/papel-higienico-rolo-santher-ehr50',tag:'Papel Higiênico'},
        {name:'Toalha ITI01 Inovatta',desc:'Melhor custo-benefício. 10x240 folhas.',url:'/products/papel-toalha-interfolhado-santher-iti01-folha-simples',tag:'Toalha'},
        {name:'Sabonete Espuma Santher',desc:'Rendimento superior. Para dispensers.',url:'/blogs/novidades/sabonete-espuma-santher-dispensers-quartz',tag:'Sabonete',cta:'Ver a linha'}
      ],
      clinica: [
        {name:'Personal VIP Interfolhado',desc:'Folha dupla ultra macia. Premium.',url:'/products/papel-higienico-interfolhado-santher-phi12-personal-vip',tag:'Papel Higiênico'},
        {name:'Toalha ITI03 Folha Tripla',desc:'Topo da linha. Textura tipo tecido.',url:'/products/papel-toalha-interfolhado-santher-iti03-folha-tripla',tag:'Toalha'},
        {name:'Sabonete Espuma Santher',desc:'Ideal para ambientes de saúde.',url:'/blogs/novidades/sabonete-espuma-santher-dispensers-quartz',tag:'Sabonete',cta:'Ver a linha'}
      ],
      hotel: [
        {name:'Personal VIP Rolão Folha Dupla',desc:'Conforto premium. 8x250m.',url:'/products/papel-higienico-rolo-santher-personal-vip-8x250m',tag:'Papel Higiênico'},
        {name:'Toalha ITI03 Folha Tripla',desc:'A mais premium da Santher.',url:'/products/papel-toalha-interfolhado-santher-iti03-folha-tripla',tag:'Toalha'},
        {name:'Sabonete Espuma Santher',desc:'Aroma premium para hóspedes.',url:'/blogs/novidades/sabonete-espuma-santher-dispensers-quartz',tag:'Sabonete',cta:'Ver a linha'}
      ],
      restaurante: [
        {name:'Rolão 500m EHR50',desc:'Econômico e prático. 4.000m/cx.',url:'/products/papel-higienico-rolo-santher-ehr50',tag:'Papel Higiênico'},
        {name:'Toalha Bobina ETB20',desc:'Alto fluxo. 2.000m por caixa.',url:'/products/papel-toalha-bobina-santher-etb20',tag:'Toalha'},
        {name:'Sabonete Espuma Santher',desc:'Higiene ANVISA compliant.',url:'/blogs/novidades/sabonete-espuma-santher-dispensers-quartz',tag:'Sabonete',cta:'Ver a linha'}
      ],
      condominio: [
        {name:'Rolão 500m EHR50',desc:'Campeão de vendas. Melhor custo/metro.',url:'/products/papel-higienico-rolo-santher-ehr50',tag:'Papel Higiênico'},
        {name:'Toalha Eco ETI00 3 Dobras',desc:'Menor custo por folha da Santher.',url:'/products/papel-toalha-interfolhado-santher-eti00-eco',tag:'Toalha'},
        {name:'Sabonete Espuma Santher',desc:'Economia para áreas comuns.',url:'/blogs/novidades/sabonete-espuma-santher-dispensers-quartz',tag:'Sabonete',cta:'Ver a linha'}
      ],
      colegio: [
        {name:'Rolão 500m EHR50',desc:'Alta metragem = menos trocas.',url:'/products/papel-higienico-rolo-santher-ehr50',tag:'Papel Higiênico'},
        {name:'Toalha ITI02 Folha Dupla',desc:'Boa absorção, preço justo.',url:'/products/papel-toalha-interfolhado-santher-iti02-folha-dupla',tag:'Toalha'},
        {name:'Sabonete Espuma Santher',desc:'Ideal para alto fluxo estudantil.',url:'/blogs/novidades/sabonete-espuma-santher-dispensers-quartz',tag:'Sabonete',cta:'Ver a linha'}
      ]
    };
    var prods = products[tipo] || products.escritorio;
    var html = '';
    prods.forEach(function(p){
      html += '<a href="'+p.url+'" style="display:block;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:12px;padding:20px;text-decoration:none;color:#e6edf3;transition:transform .2s,border-color .2s;" onmouseover="this.style.borderColor=\'#1a7a5a\';this.style.transform=\'translateY(-2px)\'" onmouseout="this.style.borderColor=\'rgba(255,255,255,0.1)\';this.style.transform=\'none\'">'
        +'<span style="display:inline-block;background:#1a7a5a;color:#fff;padding:3px 10px;border-radius:20px;font-size:.75rem;font-weight:600;margin-bottom:8px;">'+p.tag+'</span>'
        +'<h4 style="margin:8px 0 4px;font-size:1.05rem;color:#fff;">'+p.name+'</h4>'
        +'<p style="margin:0;font-size:.9rem;color:#8b949e;">'+p.desc+'</p>'
        +'<span style="display:inline-block;margin-top:10px;color:#1a7a5a;font-weight:600;font-size:.85rem;">'+(p.cta||'Ver produto')+' →</span>'
        +'</a>';
    });
    recoCards.innerHTML = html;
  }

  // v15: a mensagem já sai com o código sugerido pra cada item (os mesmos dos cards acima), pronta pra equipe montar o orçamento.
  // Toalha interfolhada: a caixa tem 2.400 folhas (10 pacotes de 240), então caixas = pacotes / 10, arredondado pra cima.
  var sug = {
    escritorio:  {phi:'EHR50 (rolão 500 m)', toa:'ITI01', bob:false},
    clinica:     {phi:'PHI12 (Personal VIP interfolhado)', toa:'ITI03', bob:false},
    hotel:       {phi:'PHR25 (Personal VIP rolão 250 m)', toa:'ITI03', bob:false},
    restaurante: {phi:'EHR50 (rolão 500 m)', toa:'ETB20 (bobina)', bob:true},
    condominio:  {phi:'EHR50 (rolão 500 m)', toa:'ETI00', bob:false},
    colegio:     {phi:'EHR50 (rolão 500 m)', toa:'ITI02', bob:false}
  }[tipo] || {phi:'EHR50 (rolão 500 m)', toa:'ITI01', bob:false};
  var pl = function(n, um, varios){ return n+' '+(n === 1 ? um : varios); };
  var linhaToa = sug.bob
    ? '• Toalha: '+pl(toa_pcts,'pacote','pacotes')+' — sugestão '+sug.toa+', a equipe calcula as caixas'
    : '• Toalha: '+pl(toa_pcts,'pacote','pacotes')+' de 240 folhas ≈ '+Math.max(1, Math.ceil(toa_pcts/10))+' cx '+sug.toa;
  var msg = 'Olá! Fiz a conta na calculadora do site:\n• '+tipoL+' · '+colab+' colaboradores ('+mulh+'% mulheres) · '+banh+' banheiros · '+vis+' visitas/dia · '+horas+' h/dia\n\nConsumo estimado por mês:\n• Papel higiênico: '+pl(phi_pcts,'pacote','pacotes')+' — sugestão '+sug.phi+'\n'+linhaToa+'\n• Sabonete: '+pl(sab_refs,'refil','refis')+' — linha espuma Santher\n\nDispensers em comodato: '+d_phi+' higiênico + '+d_toa+' toalha + '+d_sab+' sabonete\n\nQuero a proposta com comodato.';
  var btn = g('jpc-btn');
  if(btn) { btn.href = 'https://wa.me/5521991893818?text=' + encodeURIComponent(msg); btn.setAttribute('data-cta','site_calculadora'); btn.setAttribute('target','_blank'); btn.setAttribute('rel','noopener'); }
};

window.jpcInit = function() {
  var el = document.getElementById('jpc-colab');
  if (el) {
    window.jpcCalc();
    ['jpc-colab','jpc-mulh','jpc-banh','jpc-vis','jpc-h','jpc-tipo'].forEach(function(id){
      var e = document.getElementById(id);
      if(e){ e.addEventListener('input', window.jpcCalc); e.addEventListener('change', window.jpcCalc); }
    });
  } else {
    setTimeout(window.jpcInit, 150);
  }
};

// Contadores animados
window.jpcCounters = function() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-count]').forEach(function(c){ c.textContent = parseInt(c.dataset.count).toLocaleString('pt-BR'); });
    return;
  }
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) {
        var t=parseInt(e.target.dataset.count), s=0, step=t/90;
        var iv=setInterval(function(){ s+=step; if(s>=t){s=t;clearInterval(iv);} e.target.textContent=Math.floor(s).toLocaleString('pt-BR'); },16);
        obs.unobserve(e.target);
      }
    });
  }, {threshold:0.5});
  document.querySelectorAll('[data-count]').forEach(function(c){ obs.observe(c); });
};

// Inicializa quando DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function(){ window.jpcInit(); window.jpcCounters(); });
} else {
  window.jpcInit(); window.jpcCounters();
}